import SubjectsPage from '../components/subjects/SubjectsPage';

$(() => {
    void (new SubjectsPage({ el: '.js-browseContent' }));
});
